import { render, staticRenderFns } from "./WapTitle.vue?vue&type=template&id=5671b627&scoped=true&"
import script from "./WapTitle.vue?vue&type=script&lang=js&"
export * from "./WapTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671b627",
  null
  
)

export default component.exports